(ns app.front.view.application.permissions
  (:require [app.front.entities :as entities]
            [potpuri.core :as p]))

(defn ws-child-has-permission? [permission ws-child]
  (-> ws-child
      :granted-permissions
      set
      permission))


(defn user-has-permission-for-workspace? [ws-child-types permission workspace-eid ents]
  (->> ents
       (filter #(and (= (:entity/parent %) workspace-eid)
                     (->> % :entity/type (contains? ws-child-types))))
       (some (partial ws-child-has-permission? permission))))


(defn user-has-permission-for-current-application? [ws-child-types permission db]
  (let [workspace-id  (-> db :view/workspace :workspace/id)
        ents          (-> db ::entities/entity-db vals)
        workspace-eid (-> ents
                          (p/find-first {:workspace/id workspace-id})
                          :db/id)]
    (user-has-permission-for-workspace? ws-child-types permission workspace-eid ents)))

(def can-read-inspections-as-authority?
  (partial user-has-permission-for-current-application?
           #{:entity.type/pre-consultation :entity.type/application :entity.type/execution}
           :permission.inspection/authority-read))

(def can-bypass-acknowledgement?
  (partial user-has-permission-for-current-application?
           #{:entity.type/execution}
           :permission.inspection/authority-read))

(def can-send-workspace-messages?
  (partial user-has-permission-for-workspace?
           #{:entity.type/pre-consultation :entity.type/application :entity.type/execution}
           :permission.conversation/write))
